import {Component, Input} from "@angular/core";
import {IAction} from "../../definitions";
import {UI_TEXTS} from "../../enums/e-texts";
import {FactoryService} from "../../services/factory.service";
import {JP} from "../../helpers/jp";


@Component({
  selector: "nv-actions",
  templateUrl: "./nv-actions.component.html"
})


export class NvActionsComponent {
  UI_TEXTS = UI_TEXTS;

  public selected: IAction;
  private _document: any;
  private _pointer: string;
  private _title: string;

  @Input() prop: any;

  @Input() set document(v: any) {
    this._document = v;
  };

  @Input() set pointer(v: string) {
    this._pointer = v;
  }

  @Input() set title(v: string) {
    this._title = v;
  }

  get document() { return this._document; }
  get pointer() { return this._pointer; }
  get title() { return this._title || "no title"; }
  get actions(): IAction[] { return JP.get(this.document, this.pointer); }


  constructor(private factoryService: FactoryService) {
  }


  onItemSelected(r: IAction) {
    this.selected = r;
  }


  getItemLabel(action: IAction) {
    return `id: ${action.id}`;
  }


  onAddClick() {
    this.factoryService.gameObjectUtils.addActionTo(this.document, this.pointer);
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-actions/nv-actions.component.ts